export const translations = {
  obrigatorio: {
    pt: "Obrigatório",
    en: "Mandatory",
    de: "Pflichtfeld",
    es: "Obligatorio",
  },
  novoFornecedor: {
	pt: "Novo Fornecedor",
	en: "New Supplier",
	de: "Neuer Lieferant",
	es: "Nuevo Proveedor",
  },

  configuracoes: {
    pt: "Configurações",
    en: "Settings",
    de: "Einstellungen",
    es: "Configuración",
  },
  selecione: {
    pt: "Selecione...",
    en: "Select...",
    de: "Auswählen...",
    es: "Seleccione...",
  },
  provincy: {
    pt: "Província",
    en: "State",
    de: "Länder",
    es: "Província",
  },
  complemento: {
    pt: "Complemento",
    en: "Complement",
    de: "Ergänzung",
    es: "Complemento",
  },
  postalCode: {
    pt: "Código postal",
    en: "Zip code",
    de: "Postleitzahl",
    es: "Código postal",
  },
  nomeFantasia: {
    pt: "Nome Fantasia",
    en: "Fantasy name",
    de: "Fantasiename",
    es: "Nombre de fantasía",
  },
  inscricaoEstatual: {
    pt: "Inscrição Estadual",
    en: "State registration",
    de: "Staatliche Registrierung",
    es: "Registro estatal",
  },

  telefone: {
    pt: "Telefone",
    en: "Telephone",
    de: "Telefon",
    es: "Teléfono",
  },
  cnpj: {
    pt: "CNPJ",
    en: "CNPJ",
    de: "CNPJ",
    es: "Numero de Identificacion",
  },
  razaoSocial: {
    pt: "Razão Social",
    en: "Social Reason",
    de: "Soziale Vernunft",
    es: "Razón Social",
  },
  uf: {
    pt: "UF",
    en: "Federative unit",
    de: "Föderative Einheit",
    es: "Estado/Provincia",
  },
  cep: {
    pt: "Cep",
    en: "Zip code",
    de: "Postleitzahl",
    es: "Código postal",
  },
  lougradouro: {
    pt: "Logradouro",
    en: "Public place",
    de: "Öffentlicher Platz",
    es: "Direccion",
  },
  numero: {
    pt: "Número",
    en: "Number",
    de: "Nummer",
    es: "Número",
  },
  codigo: {
    pt: "Código",
    en: "Code",
    de: "Zentrums",
    es: "Código",
  },
  bairro: {
    pt: "Bairro",
    en: "Número",
    de: "Gegend",
    es: "Barrio",
  },
  cidade: {
    pt: "Cidade",
    en: "City",
    de: "Stadt",
    es: "Ciudad",
  },
  latitude: {
    pt: "Latitude",
    en: "Latitude",
    de: "Breite",
    es: "Latitud",
  },
  longitude: {
    pt: "Longitude",
    en: "Longitude",
    de: "Längengrad",
    es: "Longitud",
  },
  email: {
    pt: "E-mail",
    en: "E-mail",
    de: "E-mail",
    es: "Correos electrónico",
  },
  cancelar: {
    pt: "Cancelar",
    en: "Cancel",
    de: "kündiger",
    es: "Cancelar",
  },
  filtrar: {
    pt: "Filtrar",
    en: "Filter",
    de: "Filter",
    es: "Filtrar",
  },
  voltar: {
    pt: "Voltar",
    en: "Go back",
    de: "Geh zurück",
    es: "Regresa",
  },
  cadastrar: {
    pt: "Cadastrar",
    en: "Register",
    de: "Katastern",
    es: "Register",
  },
  cnpjInvalido: {
    pt: "CNPJ Inválido",
    en: "Invalid CNPJ",
    de: "Ungültiger CNPJ",
    es: "CNPJ no válido",
  },
  emailInvalido: {
    pt: "Email inválido",
    en: "Invalid email",
    de: "Ungültige EMail",
    es: "Email inválido",
  },
  CEPnaoEncontrado: {
    pt: "CEP não encontrado",
    en: "CEP not found",
    de: "CEP nicht gefunden",
    es: "CEP no encontrado",
  }
};
